/* eslint-disable no-plusplus */
import { FormInstance } from 'antd';
import { myOrdersContext } from 'contexts/MyOrdersContext';
import FormFiltersFields from 'model/FormFiltersFields';
import { Order } from 'model/Order';
import { useCallback, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { generateOrdersExcel } from 'services/ordersService';
import { sessionSelectors } from 'store/state/selectors';
import { generateOrderParam } from 'utils/util';
import NestedTable from './NestedTable';

export function useMyOrdersReport(
  form: FormInstance,
  data: Order[] | undefined,
) {
  const customerId = useSelector(sessionSelectors.getSelectedCustomerId);
  const { setLoading } = useContext(myOrdersContext);

  const downloadFile = useCallback((blob: Blob, fileName: string) => {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.style.display = 'none';
    link.download = fileName;
    link.click();
  }, []);

  const convertToBlob = useCallback((binaryStringData: string) => {
    const binaryString = window.atob(binaryStringData);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    const fileData = bytes;

    const blob = new Blob([fileData], { type: 'application/octet-stream' });
    return blob;
  }, []);

  const downloadExcel = () => {
    const formFilters: FormFiltersFields = form.getFieldsValue();
    const filtersParams = generateOrderParam(formFilters);
    setLoading(true);
    generateOrdersExcel({
      ...filtersParams,
      'Data.CustomerId': customerId,
    })
      .then((response) => {
        setLoading(false);
        const blob = convertToBlob(response.data.data);
        downloadFile(blob, 'pedidos.xlsx');
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const sortPrintTableOrders = useCallback(
    () =>
      data?.sort((actual: Order, next: Order) =>
        actual.description.localeCompare(next.description),
      ),
    [data],
  );

  const print = () => {
    const tempDiv = document.createElement('div');
    const sortedOrders = sortPrintTableOrders();
    ReactDOM.render(<NestedTable row={sortedOrders ?? []} />, tempDiv);
    tempDiv.innerHTML += `<style type="text/css">table {border-collapse: collapse;}tr { border-bottom: 1px solid #bab3b3;}</style>`;
    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    document.body.appendChild(frame);
    frame.contentDocument?.write(tempDiv?.innerHTML || '');
    frame.focus();
    frame.contentWindow?.print();
    frame.parentNode?.removeChild(frame);
  };

  return { downloadExcel, print };
}
